import { Button, Card, Col, Divider, Form, Input, notification, Row, Space } from "antd";
import { RequiredMark } from "antd/lib/form/Form";
import TextArea from "antd/lib/input/TextArea";
import { useState } from "react";
import { useLocation, useNavigate, useOutletContext, useParams } from "react-router";
import { getEnvironmentService } from "../../backend";
import { AwsRegionType, IEnvDetails } from "../../types";
import { CreateStageRequestCloudProviderEnum, CreateStageRequestInfrastructureAsCodeToolEnum } from "@microtica/ms-engine-sdk";
export default function EnvironmentSettingsClone() {
    const navigate = useNavigate();
    const [envForm] = Form.useForm();
    const { projectId, envId } = useParams() as { projectId: string; envId: string; };
    const { env } = useOutletContext<{ env: IEnvDetails }>();
    const [requiredMark] = useState<RequiredMark>('optional');
    const [loadingCloneEnv, setLoadingCloneEnv] = useState(false);

    async function handleUpdate(values: { name: string, description: string }) {
        try {
            setLoadingCloneEnv(true);
            const cloudProvider = env.cloudProvider === "aws" ?
                CreateStageRequestCloudProviderEnum.Aws :
                CreateStageRequestCloudProviderEnum.Google;
            const infrastructureAsCodeTool = env.cloudProvider === "aws" ?
                CreateStageRequestInfrastructureAsCodeToolEnum.Cloudformation :
                CreateStageRequestInfrastructureAsCodeToolEnum.Terraform;

            const { data: { id } } = await getEnvironmentService().createStage(
                projectId,
                {
                    copyFrom: envId,
                    name: values.name,
                    description: values.description,
                    cloudProvider,
                    infrastructureAsCodeTool
                }
            );
            notification.success({ message: `${env.name} environment has been cloned sucessfully.` });
            navigate(`/projects/${projectId}/environments`);
            navigate(`/projects/${projectId}/environments/${id}`);
            // window.location.reload();
        } catch (error: any) {
            notification.error({
                message: "Clone environment failed",
                description: error.response.data.message
            });
        } finally {
            setLoadingCloneEnv(false);
        }
    }

    return (
        <Card bordered>
            <Card.Meta
                title="Clone Environment"
                description="Make a copy of your existing environment."
            />
            <Divider />
            <Form
                form={envForm}
                layout="vertical"
                onValuesChange={() => { }}
                requiredMark={requiredMark}
                wrapperCol={{}}
                onFinish={handleUpdate}
            >
                <Form.Item
                    name="name"
                    label="New environment name"
                    required
                    rules={[{ required: true, message: 'Please enter environment name!' }]}
                >
                    <Input placeholder="DEV clone" style={{ width: "100%" }} />
                </Form.Item>
                <Form.Item
                    name="description"
                    label="New environment description"
                    required
                    rules={[{ required: true, message: 'Please enter environment description!' }]}
                >
                    <TextArea placeholder="My environment clone" maxLength={200} style={{ height: 100, marginBottom: "20px" }} />
                </Form.Item>
                <Divider />
                <Row style={{
                    display: "flex",
                    alignItems: "center"
                }}>
                    <Col span={24} style={{ textAlign: "right" }}>
                        <Button htmlType="submit" loading={loadingCloneEnv}>
                            Clone
                        </Button>
                    </Col>
                </Row>
            </Form>
        </Card>
    );
}